module.exports = __webpack_public_path__ + "img/tv7.6d6c130b.gif";